/* eslint-disable */
import {
  postConexion,
  putConexion,
  getConexion,
  getConexionHeaders,
} from '../../conexion/Conexion';

/* prettier-ignore */
export const getAllUsersByBusinessId = () => async (objUser: any): Promise<any> => {
  const users = await postConexion('users/getUsersByBusinessId', objUser);

  return users;
};

export const updateBusiness = async (objUser: any): Promise<any> => {
  await putConexion('cash/business', objUser);
};

export const disableBusiness = async (objUser: any): Promise<any> => {
  await postConexion('cash/disableBusiness', objUser);
};

export const setCashOportunity = async (obj: any): Promise<any> => {
  await postConexion('cash/saveCostoOportunidad', obj);
};

export const setPerformance = async (obj: any): Promise<any> => {
  await postConexion('cash/saveTasaRendimiento', obj);
};

export const getCashOportunity = async (): Promise<any> => {
  // const obj = {
  //   accessToken
  // };
  const cost = await getConexion('cash/getLastCostoOportunidad');
  return cost;
};

export const saveTransCost = async (obj: any): Promise<any> => {
  const value = {
    valor: obj,
  };
  await postConexion('cash/saveTransCost', value);
};

export const saveMinCash = async (obj: any): Promise<any> => {
  const value = {
    valor: obj,
  };
  await postConexion('cash/saveMinCash', value);
};

export const getTarProm = async (obj: any): Promise<any> => {
  const info = await getConexionHeaders(
    'cash/getTarProm',
    `?businessId=${obj}`
  );
  return info;
};

export const saveContract = async (obj: any): Promise<any> => {
  const value = {
    detail: obj,
  };
  await postConexion('cash/saveClientContract', value);
};

export const updateFlagContract = async (obj: any): Promise<any> => {
  await putConexion('cash/business', obj);
};

export const getProvidersByCompany = async (obj: any): Promise<any> => {
  const info = await getConexionHeaders(
    'cash/getProvidersByCompany',
    `?business_id=${obj}`
  );
  return info;
};

export const updateSupplierRequest = async (obj: any): Promise<any> => {
  await putConexion('proveedor/updateSupplierRequest', obj);
};

export const updateSupplierRequestAll = async (obj: any): Promise<any> => {
  await putConexion('proveedor/updateSupplierRequestAll', obj);
};

export const updateSupplierAmount = async (obj: any): Promise<any> => {
  await putConexion('proveedor/updateSupplierAmount', obj);
};

export const getProvidersSelectedNotification = async (
  obj: any
): Promise<any> => {
  const info = await getConexionHeaders(
    'cash/prepareDailySuggestionsProvs',
    `?business_id=${obj}`
  );
  return info;
};

export const sendNotificationProviders = async (obj: any): Promise<any> => {
  const info = await getConexionHeaders(
    'cash/generateDailySuggestionsProvs',
    `?business_id=${obj}`
  );
  return info;
};
